import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell8InchLandscape from 'public/images/tablet-shells/FireTabletsFeatureRotator_8Inch_Landscape_KH_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  FONT_FAMILY,
  TEXT_COLOR,
  MAX_LINES,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
} from '../constants';

export const TABLET_8INCH_LANDSCAPE_KH: PreviewStateConfig = {
  label: '8" Landscape KH',
  altText: ALT_TEXT,
  dimensions: { width: 1008, height: 600 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 60,
        y: 216,
        width: 888,
        height: 272,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 60, y: 216, width: 567, height: 272 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 247,
        maxHeight: 100,
        position: { x: 101, y: 252 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 101,
        y: 362,
      },
      fontSize: 20,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 300,
      maxLines: MAX_LINES,
      lineHeight: 28,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 60, y: 216, width: 888, height: 35 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 60, y: 418, width: 888, height: 70 },
    },
    { type: LayerType.SHELL, src: shell8InchLandscape },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
